<template>
    <div>
        <main class="main-content main-content-case-videos">
            <div class="container-fluid container-case-videos --blue">
                <div class="row">
                    <div class="col-12">
                        <p class="case-videos-title"><strong>VÍDEOS</strong></p>
                    </div>
                </div>
            </div>

            <div class="container-fluid container-videos">
                <div class="container">
                    <div class="row" v-if="video">
                        <div class="col-12 col-lg-5">
                            <div class="masaic-video__infos mosaic-container masaic-video">
                                <p class="masaic-video__date">{{new Date(video.meta.first_published_at).toLocaleDateString('pt-BR')}}</p>
                                <p class="masaic-video__title">{{video.title}}</p>
                                <p class="masaic-video__subtitle">{{video.description}}</p>
                                <Share :title="title" />
                            </div>
                        </div>
                        <div class="col-12 col-lg-6 offset-lg-1">
                            <div class="video-item">
                                <div class="model-iframe">
                                    <div class="video-container">
                                        <!-- Pegar video id dinâmico e trocar por: RVXG_4zQSj0 -->
                                        <iframe 
                                            width="100%" 
                                            height="400" 
                                            :src="`https://www.youtube.com/embed/${video.video_code}?autoplay=0&amp;rel=0&amp;controls=1&amp;showinfo=0`" 
                                            frameborder="0" 
                                            allowfullscreen="" 
                                            class="movieEmbedList">
                                        </iframe>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-else>
                        <div class="col-12">
                            <content-loader 
                                class="d-none d-lg-block"
                                style="margin: 40px auto; display:block"
                                width="1110"
                                height="350">

                                <rect x="1" y="1" rx="0" ry="0" width="100" height="18" /> 
                                <rect x="1" y="30" rx="0" ry="0" width="445" height="120" /> 
                                <rect x="1" y="160" rx="0" ry="0" width="150" height="25" /> 
                                <rect x="1" y="200" rx="0" ry="0" width="200" height="30" /> 
                                <rect x="570" y="1" rx="0" ry="0" width="540" height="303" /> 
                            </content-loader>

                            <content-loader 
                                class="d-lg-none d-md-block"
                                style="margin: 40px auto; display:block"
                                width="690"
                                height="650">

                                <rect x="1" y="1" rx="0" ry="0" width="100" height="18" /> 
                                <rect x="1" y="30" rx="0" ry="0" width="690" height="100" /> 
                                <rect x="1" y="150" rx="0" ry="0" width="150" height="25" /> 
                                <rect x="1" y="190" rx="0" ry="0" width="200" height="30" /> 
                                <rect x="1" y="250" rx="0" ry="0" width="690" height="338" /> 
                            </content-loader>
                        </div>
                    </div>
                </div>
            </div>

            <div class="container container-banner">
                <div class="row">
                    <div class="col-12">
                        <div id='div-gpt-ad-1603501550614-0'></div>
                    </div>
                </div>
            </div>

            <div class="container container-list-videos" v-if="related">
                <div class="row row-seetoo">
                    <div class="col-12 content-seetoo">
                        <h2 class="title-blue">Veja também</h2>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-md-4 col-lg-3" v-for="video in related" :key="video.id">
                        <router-link :to="video.url" target="_self" class="noticies-item">
                            <div class="noticies-item--image">
                                <img :src="utils.image(video.thumbnail, 265,168)" alt="">
                            </div>
                            <div class="noticies-item--info">
                            <p class="noticies__label noticies__label--white">
                                {{new Date(video.first_published_at).toLocaleDateString('pt-BR')}}
                            </p>
                                <p class="noticies__title noticies__title--small noticies__title--white">
                                    <strong>{{video.title}}</strong>
                                </p>
                            </div>
                            <div class="noticies-item__play noticies-item__play--small"></div>
                        </router-link>
                    </div>
                </div>
            </div>
        </main>
        <NotFound v-if="NOT_FOUND" />
        <Error v-if="ERROR" />
    </div>
</template>

<script>
import page from '@/api/page'
import utils from '@/utils'
import Share from '@/components/Share'

import NotFound from '@/views/NotFound'
import Error from '@/views/Error'

import { ContentLoader } from 'vue-content-loader'

export default {
    name: "Detail",
    props:['content'],
    components:{Share, NotFound, Error, ContentLoader},
    head: {
        title: function() {
            return{
                inner:this.title
            }
        }
    },
    data() {
        return {
            utils:utils,
            video:null,
            related: null,
            title:'',
            NOT_FOUND: false,
            ERROR: false,
        }
    },
    watch:{
        video: function () {
            this.title = this.video.title
            this.related = this.video.related.concat(this.video.related_extra)
            this.$emit('updateHead')
            
        }
    },
    methods:{
        async getVideo() {
            if (!this.content) {
                const response = await page.get(`find?html_path=${this.$route.path}`)
    
                if(response.ok) {
                    this.video = response.data
                    this.ping()
                } else {
                    if (response.status === 404) {
                        this.NOT_FOUND = true
                    } else if (response.status >= 500) {
                        this.ERROR = true
                    }
                }
            } else {
                this.video = this.content
            }
        },
        ping(){
            page.get(`${this.video.id}/ping`)
        },
    },
    created() {
        this.getVideo()
    },
    mounted() {

        var googletag = window.googletag
        googletag.cmd.push(function() {
            googletag.destroySlots()
            googletag.defineSlot('/1513505/v1_gweb_superbanner_topo', [[970,250], [300, 100], [728, 90]], 'div-gpt-ad-1603501550614-0').addService(googletag.pubads());
            googletag.pubads().enableSingleRequest();
            googletag.pubads().collapseEmptyDivs()
            googletag.enableServices();
            googletag.display('div-gpt-ad-1603501550614-0');
        })
        window._ppads.checksBeforeLoad()
    }
}
</script>